module.exports = __webpack_public_path__ + "img/express-flower-gel-double-tensor-6-small@2x.1cd4153a.jpg";